import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from "react";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTheme, useMediaQuery, Button, TextField } from "@mui/material";
import nodata from "../../Img/newnodta.gif";
import OutlinedInput from "@mui/material/OutlinedInput";
import consts from '../../constant';
import { useLocation, useNavigate } from 'react-router-dom';
import $ from "jquery";
import { useEffect } from 'react';
import Context from '../../Context'
import { useContext } from 'react';
import FormControl from "@mui/material/FormControl";
import usercalls from "../../Axios";
import axios from "axios";
import { toast } from 'react-toastify';
import Tooltip from '@mui/material/Tooltip';

export default function Positions() {
  const theme = useTheme();
  const mobilemd = useMediaQuery(theme.breakpoints.up("md"));

  const scrollRef = React.useRef(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [current_activeTab, setcurrent_ActiveTab] = useState("Subscription History");
  const [current_activeTab1, setcurrent_ActiveTab1] = useState("Last 7 D");

  const { openPositionsData, setOpenPositionsData, setBalanceUpdate } = useContext(Context)

  const [futureSocketToken, setFutureSocketToken] = useState("");


  // console.log(openPositionsData, "openPositionsData")

  function calculateMarginRatio(data) {
    // Extract necessary values
    let maintMargin = parseFloat(data.maintMargin);  // Maintenance Margin
    let unrealizedProfit = parseFloat(data.unRealizedProfit);  // Unrealized PnL (can be negative)
    let accountBalance = parseFloat(data.isolatedWallet);  // Isolated Wallet Balance

    // Calculate denominator: Account Balance + Unrealized PnL
    let denominator = accountBalance + unrealizedProfit;

    // Ensure denominator is positive (avoid division by zero)
    if (denominator <= 0) {
      return "Liquidation Risk: Insufficient Margin!";
    }

    // Apply the Margin Ratio formula
    let marginRatio = (maintMargin / denominator) * 100;

    return marginRatio.toFixed(2); // Return as a percentage with 2 decimal places
  }

  const [statusLoad, setStatusLoad] = useState(false)
  const navigate = useNavigate();

  const [posData, setPosData] = useState([])

  const [multiplierError, setMultiplierError] = useState("")

  const path = usercalls();
  const PlaceFutureOrder = async (payloads, type) => {
    try {

      // console.log(payloads, type, "types")

      if (payloads?.quantity > payloads?.value) return toast.error("Quantity Exists")

      var payload = {
        type: type,
        quantity: Number(payloads?.quantity),
        symbol: payloads?.pair,
        side: payloads?.order_type == "buy" ? "sell" : "buy",
        tradeType: "future",
        marginAccount: payloads?.marginAccount,
        positionSide: payloads?.positionSide
      }


      if (type == "limit") {
        payload.price = Number(payloads?.Userprice)
      }

      // console.log("🚀 ~ PlaceFutureOrder ~ payload:", payload)

      const url = `${consts.BackendUrl}/kucoin/kucoinFutureTrade`;
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success == true) {
        toast.success(result?.message)
        setBalanceUpdate(Math.random(6))
      } else {
        toast.error(result?.message);
        if (result?.message == "Please Verify KYC") {
          setTimeout(() => {
            navigate("/Kycverify");
          }, 1000);
        }
      }
      setStatusLoad(false);
    } catch (error) {
      console.log(error, "error")
      setStatusLoad(false);
    }
  }

  const [onerun, setonerun] = useState(true)

  useEffect(() => {
    if (onerun && posData?.length > 0) {
      const targetNodes = document.querySelectorAll("[class^='mark-pricesses-']");
      // console.log("🚀 ~ useEffect ~ targetNodes:", targetNodes)
      if (targetNodes.length === 0) return;

      const config = { childList: true, subtree: true };
      setonerun(false)
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach(mutation => {
          if (mutation.type === "childList" && mutation.target) {
            const symbol = mutation.target.className.split("mark-pricesses-")[1];
            // console.log("🚀 ~ observer ~ symbol:", symbol)
            const newPrice = mutation.target.innerText;
            if (symbol) {
              var positionSize = document.getElementById(`positionAmount-${symbol}`)?.innerText
              var entryPrice = document.getElementById(`entryPrice-${symbol}`)?.innerText
              var markPrice = newPrice
              var positionType = document.getElementById(`positionSide-${symbol}`)?.innerText
              var leverage = document.getElementById(`leverage-${symbol}`)?.innerText

              // console.log(`Position Size: ${positionSize}, Entry Price: ${entryPrice}, Mark Price: ${markPrice}, Position Type: ${positionType}, Leverage: ${leverage}`);
              if (positionSize && entryPrice && markPrice && positionType && leverage) {
                // console.log("Calculated")

                let pnl = 0;
                let pnlPercentage = 0;

                if (positionType.toLowerCase() === "long") {
                  pnl = (markPrice - entryPrice) * positionSize;
                  pnlPercentage = ((markPrice - entryPrice) / entryPrice) * 100;
                } else if (positionType.toLowerCase() === "short") {
                  pnl = (entryPrice - markPrice) * positionSize;
                  pnlPercentage = ((entryPrice - markPrice) / entryPrice) * 100;
                }

                // Apply leverage effect
                let leveragedPNLPercentage = pnlPercentage * leverage;

                // document.getElementById(`pnl-${symbol}`).innerText = ` ${pnl.toFixed(2)} USDT`
                // document.getElementById(`pnlper-${symbol}`).innerText = leveragedPNLPercentage.toFixed(2) + " %"
                // Format PnL value
                const pnlColor = pnl >= 0 ? 'green' : 'red';
                const pnlHTML = `<span style="color: ${pnlColor};">${pnl.toFixed(2)} USDT</span>`;
                document.getElementById(`pnl-${symbol}`).innerHTML = pnlHTML;

                // Format PnL % value
                const pnlPercentColor = leveragedPNLPercentage >= 0 ? 'green' : 'red';
                const pnlPercentHTML = `<span style="color: ${pnlPercentColor};">${leveragedPNLPercentage.toFixed(2)} %</span>`;
                document.getElementById(`pnlper-${symbol}`).innerHTML = pnlPercentHTML;
              }
            }
            // console.log(`Symbol: ${symbol}, New Price: ${newPrice}`);
          }
        });
      });

      targetNodes.forEach(node => observer.observe(node, config));

      return () => observer.disconnect(); // Cleanup on unmount
    }

  }, [posData]);



  const generatekucointoken = async () => {
    try {
      axios.withCredentials = true;
      const url = `${consts.BackendUrl}/kucoin/generatekucointoken`;
      const { data } = await axios.get(url);
      if (data.success) {
        let str = data?.result?.replace(/^"(.*)"$/, "$1");
        setFutureSocketToken(str);
        // console.log(str, "kucoinToken");
      }
    } catch (err) {
      console.log(err, "error from token");
    }
  };

  useEffect(() => {
    generatekucointoken()
  }, [])

  const [futureSocket, setFutureSocket] = useState("")
  const curSocPi = React.useRef(null);

  const connectFutureSocket = async () => {
    try {
      // console.log("Connecting to Future Socket with token:", futureSocketToken);
      var pairs = openPositionsData?.map((item) => item.pair?.replace('_', '') + "M");
      // console.log("🚀 ~ connectFutureSocket ~ pairs:", pairs)
      // pairs = pairs?.filter((item, index) => pairs.indexOf(item) === index); // Remove duplicates
      // console.log(pairs, "pairs")
      const ws = new WebSocket(
        `wss://ws-api-futures.kucoin.com?token=${futureSocketToken}`
      );
      setFutureSocket(ws)
      ws.onopen = (event) => {
        const instrumentApicall = {
          "id": new Date().getTime() + 1, // ensure different ID
          "type": "subscribe",
          "topic": `/contract/instrument:${pairs?.join(',')}`,
          "response": true
        };
        // const priceApicall = {
        //   "id": new Date().getTime(),
        //   "type": "subscribe",
        //   "topic": `/contractMarket/snapshot:${pairs?.join(',')}`,
        //   "response": true
        // }
        // console.log("🚀 ~ connectFutureSocket ~ instrumentApicall:", instrumentApicall)
        ws.send(JSON.stringify(instrumentApicall));
        // ws.send(JSON.stringify(priceApicall));
      };
      ws.onmessage = function (event) {
        const json = JSON.parse(event.data);
        // console.log("🚀 ~ connectFutureSocket ~ json:", json)
        // console.log(window.filterPoint, "window.filterPointwindow.filterPoint")
        try {

          if (json?.subject == "mark.index.price") {
            // $(`.markPrice`).html(`<span > ${Number(json?.data?.markPrice)} </span>`);
            $(`.mark-pricesses-${json?.topic?.split(':')[1]}`).html(`<span > ${Number(json?.data?.markPrice)} </span>`);
          }
          // else if (json?.subject == "snapshot.24h") {
          //   const symbol = json?.data?.symbol
          //   // console.log("🚀 ~ connectFutureSocket ~ json:", json, symbol)
          //   $(`.pricesPosition-${symbol}`).html(`<span class=${Number(json?.data?.lastPrice) > 0 ? 'tr-green' : 'tr-red'} >${Number(json?.data?.lastPrice)}</span>`);
          // }
        } catch (error) {
          console.log(error, "err");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed futures");
      };
    } catch (error) {
      console.log("🚀 ~ connectFutureSocket ~ error:", error)

    }
  }

  useEffect(() => {
    if (futureSocketToken && openPositionsData?.length > 0) {
      // console.log("Mounted")
      connectFutureSocket()
    }

    return () => {
      // console.log("Unmounted")
      if (curSocPi.current) {
        clearInterval(curSocPi.current);
      }
      if (futureSocket && futureSocket.readyState === WebSocket.OPEN) {
        futureSocket.close();
        // console.log("WebSocket connection closed");
      }
      setFutureSocket(null);
    }
  }, [futureSocketToken, openPositionsData])

  useEffect(() => {
    // if (openPositionsData?.length > 0) {
    setPosData(openPositionsData)
    // }
  }, [openPositionsData])


  useEffect(() => {
    if (futureSocket) {
      curSocPi.current = setInterval(() => {
        if (futureSocket?.readyState === WebSocket.OPEN) {
          const pingMsg = {
            id: `ping-${Date.now()}`,
            type: "ping",
          };
          futureSocket?.send(JSON.stringify(pingMsg));
          // console.log('Sent ping json:', pingMsg.id);
        }
      }, 20000);
    }

  }, [futureSocket])


  return (
    <>
      <div className='history_inner_tab' >
        <div className='h_tabs'>
          <button
            className={`history_button ${current_activeTab === "Subscription History" ? "active" : ""}`}
            onClick={() => setcurrent_ActiveTab("Subscription History")}
          >
            Trade Positions
          </button>
          {/* <button
              className={`history_button bddr ${current_activeTab === "Redemption History" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab("Redemption History")}
            >
              Redemption History
            </button> 
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 7 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 7 D")}
            >
              Last 7 D
            </button>
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 30 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 30 D")}
            >
              Last 30 D
            </button>
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 180 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 180 D")}
            >
              Last 180 D
            </button> */}
          <ChevronRightIcon sx={{ display: !mobilemd ? 'block' : 'none' }} className="scroll-btn" onClick={scrollRight} />

        </div>
        {current_activeTab === "Subscription History" &&
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell align="center" className="fixed-left">Pair </TableCell>
                    <TableCell align="center" >Amount	</TableCell>
                    <TableCell align="center">Value	</TableCell>
                    <TableCell align="center" >Entry Price</TableCell>
                    <TableCell align="center">Mark Price</TableCell>
                    <TableCell align="center">Liquidation Price</TableCell>
                    <TableCell align="center">Margin</TableCell>
                    <TableCell align="center">PNL</TableCell>
                    <TableCell align="center" sx={{ cursor: 'pointer', color: "#ffffff !important" }} >Close All Position</TableCell>
                    {/* <TableCell>Close</TableCell> */}
                  </TableRow>
                </TableHead>
                {posData?.length > 0 ? (
                  posData?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center" className="fixed-left">
                        {row?.pair?.split("_")?.join("")}
                        <div className='display-3 mty-5 gap-10'>
                          <span id={`positionSide-${row?.pair?.split("_")?.join("")}M`}>
                            {row?.positionSide}
                          </span>
                          <div>
                            <span id={`leverage-${row?.pair?.split("_")?.join("")}M`}>
                              {row?.leverage}
                            </span>X
                          </div>

                          {row?.marginAccount}
                        </div>

                      </TableCell>
                      <TableCell align="center"  >
                        <div id={`positionAmount-${row?.pair?.split("_")?.join("")}M`} >  {row?.value}</div>
                        <div>{row?.pair?.split("_")[0]}</div>

                      </TableCell>
                      <TableCell align="center">{Number(row?.volume)} {" "} {row?.pair?.split("_")[1]}</TableCell>
                      <TableCell align="center" id={`entryPrice-${row?.pair?.split("_")?.join("")}M`} >{Number(row?.price)?.toFixed(4)}</TableCell>
                      <TableCell align="center"> <div className={`mark-pricesses-${row?.pair?.split("_")?.join("")}M`}> {Number(row?.markPrice)?.toFixed(4)}</div> </TableCell>
                      <TableCell align="center">{Number(row?.liquidationPrice)?.toFixed(4)}</TableCell>
                      {/* <TableCell>{calculateMarginRatio(row)}%</TableCell> */}
                      <TableCell align="center">{row?.marginAmount} {" "}{row?.pair?.split("_")[1]}</TableCell>
                      <TableCell align="center" id={`mark-pnl-${row?.pair?.split("_")?.join("")}M`} >
                        <div>
                          <div id={`pnl-${row?.pair?.split("_")?.join("")}M`} >
                            0 USDT
                          </div>
                          <div id={`pnlper-${row?.pair?.split("_")?.join("")}M`} >
                            0 %
                          </div>
                        </div>
                      </TableCell>
                      {/* <div style={{ display: 'none' }} id={`positionSide-${row?.pair}`}>{row?.positionSide}</div>
                      <div style={{ display: 'none' }} id={`leverage-${row?.pair}`}>{row?.leverage}</div> */}
                      <TableCell>
                        {
                          row?.buyStatus == true ?

                            <div className='display-1'>
                              <div className='display-1 table-mt-li'>
                                <Button sx={{ fontSize: '12px', margin: 0, padding: 0 }} disabled={statusLoad} onClick={() => {
                                  if (!row?.quantity) return toast.error("Please Enter Quantity")

                                  PlaceFutureOrder(row, "market")
                                }} >Market</Button>
                                <Button sx={{ fontSize: '12px', margin: 0, padding: 0 }} disabled={statusLoad} onClick={() => {
                                  if (!row?.Userprice) return toast.error("Please Enter Price")
                                  if (!row?.quantity) return toast.error("Please Enter Quantity")

                                  PlaceFutureOrder(row, "limit")
                                }} >Limit</Button>
                              </div>
                              <div className='display-1'>
                                <FormControl
                                  sx={{ width: "100px", height: '30px' }}
                                  variant="outlined"
                                  className="price-field"
                                >
                                  <OutlinedInput
                                    id="outlined-adornment-weight"
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                      "aria-label": "weight",
                                    }}
                                    sx={{ height: '30px' }}
                                    placeholder="Price"
                                    type="number"
                                    value={row?.Userprice}
                                    onChange={(e) => setPosData(prevData => prevData?.map((item, i) => i == index ? { ...item, Userprice: e.target.value } : item))}
                                  />
                                </FormControl>
                                <Tooltip title={multiplierError}>
                                  <FormControl
                                    sx={{ width: "100px", height: '30px' }}
                                    variant="outlined"
                                    className="price-field"
                                  >

                                    <OutlinedInput
                                      id="outlined-adornment-weight"
                                      aria-describedby="outlined-weight-helper-text"
                                      inputProps={{
                                        "aria-label": "weight",
                                      }}
                                      error={Boolean(multiplierError)}
                                      helperText={multiplierError}
                                      label="Error"
                                      sx={{ height: '30px' }}
                                      placeholder="Quantity"
                                      type="number"
                                      value={row?.quantity}
                                      onChange={(e) => {
                                        setPosData(prevData => prevData?.map((item, i) => i == index ? { ...item, quantity: e.target.value } : item))
                                        var input = e.target.value
                                        if (input == "") {
                                          setMultiplierError("")
                                        }

                                        if (input != "") {
                                          const numericValue = parseFloat(input);
                                          const isMultiple = Number.isFinite(numericValue) &&
                                            Math.abs(numericValue - Math.round(numericValue / row?.multiplier) * row?.multiplier) < 1e-8;
                                          if (isMultiple) {
                                            setMultiplierError(""); // clear error
                                          } else {
                                            setMultiplierError(`Value must be a multiple of ${row?.multiplier}`);
                                          }
                                        }
                                      }

                                      }
                                    />

                                    {multiplierError && (
                                      <div
                                        style={{
                                          // position: 'absolute',
                                          // top: '100%',
                                          // left: 0,
                                          // backgroundColor: '#f44336',
                                          // color: 'white',
                                          // padding: '4px 8px',
                                          // borderRadius: '4px',
                                          // fontSize: '12px',
                                          // marginTop: '4px',
                                          // whiteSpace: 'nowrap',
                                          // zIndex: 10
                                        }}
                                      >
                                        {/* {multiplierError} */}
                                      </div>
                                    )}
                                  </FormControl>
                                </Tooltip >
                              </div>
                            </div>
                            :
                            <div>
                              you already have a open openPosition
                            </div>
                        }

                      </TableCell>
                      {/* <TableCell>{row.orderStatus}</TableCell> */}


                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                    </TableCell>
                  </TableRow>
                )}
              </Table>
            </TableContainer>
          </div >}
        {
          current_activeTab === "Redemption History" &&
          <div className="table_height">
            <TableContainer className="history_table">
              <Table>
                <TableHead>
                  <TableRow className="fixed-top">
                    <TableCell className="fixed-left">Assets</TableCell>
                    <TableCell>Order Quantity</TableCell>
                    <TableCell>Transaction Amount</TableCell>
                    <TableCell>Filled Qty</TableCell>
                    <TableCell>Avg. Filled Price</TableCell>
                    <TableCell>Trading Fee</TableCell>
                    <TableCell>Timestamp</TableCell>
                    <TableCell>Order ID</TableCell>
                    <TableCell>Order Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {tableData1.length > 0 ? (
                        tableData1.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className="fixed-left">{row.assets}</TableCell>
                            <TableCell>{row.orderQuantity}</TableCell>
                            <TableCell>{row.transactionAmount}</TableCell>
                            <TableCell>{row.filledQty}</TableCell>
                            <TableCell>{row.avgFilledPrice}</TableCell>
                            <TableCell>{row.tradingFee}</TableCell>
                            <TableCell>{row.timestamp}</TableCell>
                            <TableCell>{row.orderId}</TableCell>
                            <TableCell>{row.orderStatus}</TableCell>
                          </TableRow>
                        ))
                      ) : ( */}
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                    </TableCell>
                  </TableRow>
                  {/* )} */}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        }
      </div >
    </>
  );
}
